import { endPoints } from "@/constants/apiSetting";
import httpClient from "@/common/service/HttpClient";
const StaffProbationHdrService = {
  getPorbResultType(obj) {
    return httpClient.post(endPoints.getPorbResultType, obj);
  },
  getAllPorbAssessTemp(obj) {
    return httpClient.post(endPoints.getAllPorbAssessTemp, obj);
  },
  getStaffProbationDetail(obj) {
    return httpClient.post(endPoints.getStaffProbationDetail, obj);
  },
  getAllStaffProbationList(obj) {
    return httpClient.post(endPoints.getAllStaffProbationList, obj);
  },
  saveStaffProbation(obj) {
    return httpClient.post(endPoints.saveStaffProbation, obj);
  },
  updateStaffProbation(obj) {
    return httpClient.post(endPoints.updateStaffProbation, obj);
  },
  deleteStaffProbation(obj) {
    return httpClient.post(endPoints.deleteStaffProbation, obj);
  },
};
export default StaffProbationHdrService;



// WEBPACK FOOTER //
// ./src/service/StaffProbationHdrService.js